import React, { useEffect, useMemo } from 'react'
import { useInstData, useEventHandler } from 'tyan/public/hooks'
import { getFormValue } from 'tyan/public/utility'
import ConfirmDataDiv from './ConfirmDataDiv'

const QuoteDataApprovalInfo = props => {
    const { setState, me } = useInstData(props, useMemo(() => ({
        state: {
            id: props.match.params.id || 0
        }
    }), []))

    const { showBody: Body, onClose } = props
    const { id, initValues基本信息 } = me.state
    const statusName = getFormValue(me, '基本信息', 'statusName')

    useEffect(() => {
        handleDidMount()
    }, [])

    const handleDidMount = () => {
        Tyan.doPostEvent('PostLims', {
            data: {
                event: 'GetQuoteData',
                data: { id },
            },
            onEnd: ({ errorMessage, initValues基本信息 }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                    return
                }
                setState({ initValues基本信息, changedValues基本信息: {} })
            }
        })
    }

    const handlerFlow = (action) => {
        const onSave = (memo) => Tyan.doPostEvent('PostLims', {
            data: {
                event: 'QuoteDataFlow',
                data: { id, action, memo },
            },
            onEnd: ({ errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                    return
                }
                handlerClose()
            }
        })
        if (action == '退回申请')
            Tyan.pubForm.showDialog(action, props => <ConfirmDataDiv {...props} id={id} action={action} onSave={onSave} />)
        else onSave('')
    }

    const handlerClose = () => {
        if (window.history.length > 1)
            window.history.back()
        else WeixinJSBridge.call('closeWindow')
        // window.history.back()
        //onClose()
    }

    return !initValues基本信息 && <div text={'请稍等 ...'} /> || <Body data={me}
        controls={
            [
                { _button: '审核通过', icon: '', handler: () => Tyan.pubForm.showConfirm('确定要审核通过？', () => handlerFlow('审核通过'), onClose), cdt: () => statusName == '数据引用审核' },
                { _button: '批准通过', icon: '', handler: () => Tyan.pubForm.showConfirm('确定要批准通过？', () => handlerFlow('批准通过'), onClose), cdt: () => statusName == '数据引用批准' },
                { _button: '退回申请', icon: '', handler: () => handlerFlow('退回申请') },
                { _button: '关闭', icon: '', handler: handlerClose },
            ]
        }
        fieldsets={
            [
                { title: '', name: '基本信息', _fieldset: [{ _html: '', name: 'html', margin: 0 }], },
            ]}
    />
}

export default QuoteDataApprovalInfo